export const homepageData = {
  hero: {
    brandName: "千華駐科技出版有限公司",
    mainTitle: "從武俠世界到自然奇觀\n打開通俗閱讀的多元視野",
    subtitle:
      "千華駐科技出版有限公司出版青城十九俠系列及大華文苑書系，透過故事性、知識性與探索性兼具的作品，提供多元且易於進入的閱讀選擇。",
    tagline: "本品牌委託崧博出版經銷，官方網站由崧博出版製作。網站提供正式書籍介紹、書目查詢與合作購書通路入口。",
    ctaButtons: [
      { label: "瀏覽出版書籍", href: "/about" },
      { label: "查看合作購書通路", href: "/stores" },
    ],
  },
  about: {
    title: "認識千華駐科技",
    subtitle: "俠義文學、經典作品與大華文苑書系",
    formalName: "千華駐科技出版有限公司",
    englishName: "chianva",
    intro:
      "千華駐科技以「青城十九俠系列」與「大華文苑書系」為目前主要出版內容，透過系列化出版呈現俠義文學、經典作品與華文閱讀內容。網站提供品牌介紹、書系資訊與 2026 最新發行書籍。",
    series: [
      {
        id: "qingcheng",
        title: "青城十九俠系列",
        description: "以《青城十九俠》相關出版內容為品牌重要系列。",
        icon: "ri-sword-line",
      },
      {
        id: "dahua",
        title: "大華文苑書系",
        description: "以華文經典、文學與相關閱讀內容為主要方向的出版書系。",
        icon: "ri-book-open-line",
      },
    ],
    relationText: "本品牌委託崧博出版經銷，官方網站由崧博出版製作。",
    catalogText: "完整書名、作者與出版資訊，請前往崧博書籍資料庫查詢。",
    ctaLabel: "前往書籍資料庫",
    ctaHref: "https://catalog.sonbook.net/",
  },
  coreDirections: {
    title: "千華駐科技出版有限公司的出版內容",
    description:
      "千華駐科技出版有限公司目前以青城十九俠系列與大華文苑書系為代表內容。",
    directions: [
      {
        id: "martial",
        title: "青城十九俠",
        description: "青城十九俠系列為千華駐科技出版有限公司的重要武俠小說系列，透過人物、門派、冒險與江湖敘事，呈現武俠閱讀體驗。",
        icon: "ri-sword-line",
      },
      {
        id: "popular",
        title: "大眾閱讀",
        description: "適合一般讀者的通俗知識內容，以容易進入的敘事方式，協助讀者建立日常閱讀節奏與持續閱讀的興趣。",
        icon: "ri-book-open-line",
      },
      {
        id: "science",
        title: "自然科普",
        description: "透過易於理解的文字與主題，介紹自然現象、科學知識及與生活相關的探索內容。",
        icon: "ri-leaf-line",
      },
      {
        id: "mystery",
        title: "奇觀解謎",
        description: "從自然奇觀、世界現象與探索性題材出發，帶領讀者理解事件背後的知識、脈絡與可能解釋。",
        icon: "ri-compass-3-line",
      },
      {
        id: "dahua",
        title: "大華文苑書系",
        description: "大華文苑書系聚焦大眾閱讀、自然科普與奇觀解謎，是兼具通俗性、知識性與探索趣味的圖書系列。",
        icon: "ri-bookmark-line",
      },
    ],
  },
  bottomCta: {
    title: "從青城十九俠到大華文苑，找到下一本書",
    description:
      "透過千華駐科技出版有限公司目前公開的青城十九俠系列與大華文苑書系，查找符合個人興趣與閱讀需求的作品。",
    buttons: [
      { label: "瀏覽出版書籍", href: "/about" },
      { label: "查看合作購書通路", href: "/stores" },
    ],
  },
  footer: {
    brandSummary: "青城十九俠系列與大華文苑書系",
    description:
      "千華駐科技以「青城十九俠系列」與「大華文苑書系」為目前主要出版內容。本品牌委託崧博出版經銷，官方網站由崧博出版製作。",
    internalLinks: [
      { label: "品牌介紹", href: "/about" },
      { label: "合作通路", href: "/stores" },
      { label: "常見問題", href: "/faq" },
    ],
    externalLinks: [
      { label: "崧博出版主站", href: "https://sonbook.net/", description: "查看崧博出版與其他經銷品牌" },
      { label: "崧博書籍資料庫", href: "https://catalog.sonbook.net/", description: "查詢完整書目與出版資訊" },
    ],
  },
};

export const navLinks = [
  { label: "首頁", href: "/" },
  { label: "品牌介紹", href: "/about" },
  { label: "合作通路", href: "/stores" },
  { label: "常見問題", href: "/faq" },
  { label: "閱讀推薦", href: "/blog" },
  { label: "書籍資料庫", href: "https://catalog.sonbook.net/", external: true },
];

export const aboutPageData = {
  hero: {
    title: "關於千華駐科技出版有限公司",
    subtitle: "以青城十九俠系列與大華文苑書系為主要出版方向",
  },
  brandIntro: {
    paragraphs: [
      "千華駐科技出版有限公司以青城十九俠系列與大華文苑書系為主要出版方向。本品牌委託崧博出版經銷，官方網站由崧博出版製作。完整書目資訊可前往崧博書籍資料庫查詢。",
      "品牌透過故事性、知識性與探索性的內容，讓讀者從武俠敘事、自然現象及世界奇觀等不同主題，進入兼具閱讀趣味與知識理解的作品。對許多讀者來說，真正打開閱讀習慣的，往往不是困難的理論，而是一本容易開始、願意繼續讀下去的書。",
      "千華駐科技出版有限公司重視大眾閱讀的親近性，也重視書系整理的長期價值。透過青城十九俠系列與大華文苑書系，我們希望協助讀者找到清楚的閱讀入口，也讓經典作品與通俗閱讀重新進入日常生活。",
    ],
  },
  philosophy: {
    title: "品牌理念",
    items: [
      {
        title: "好讀，也可以有價值",
        description: "一本書能讓讀者願意開始、願意讀完、願意繼續閱讀，本身就是重要的出版價值。",
      },
      {
        title: "書系整理，是長期閱讀的入口",
        description: "系列作品能讓讀者建立閱讀順序、人物脈絡與作品世界，也讓閱讀從單本延伸到長期陪伴。",
      },
      {
        title: "經典不一定遙遠",
        description: "經典作品若透過清楚整理與友善導讀，也能重新被當代讀者接近。",
      },
      {
        title: "大眾閱讀，是培養閱讀習慣的重要力量",
        description: "越容易進入的作品，越有機會讓讀者重新建立閱讀的節奏。",
      },
    ],
  },
  directions: {
    title: "主要出版方向",
    items: [
      "武俠小說（青城十九俠）",
      "大眾閱讀",
      "自然科普",
      "奇觀解謎",
      "大華文苑書系",
    ],
  },
  targetReaders: {
    title: "適合讀者",
    description: "千華駐科技出版有限公司適合以下閱讀需求：",
    items: [
      "喜歡武俠小說與長篇故事的讀者",
      "對自然科普與奇觀解謎有興趣的讀者",
      "想找容易進入閱讀作品的人",
      "喜歡大眾閱讀與通俗讀物的人",
      "想依照書系慢慢閱讀的讀者",
      "喜歡可長期收藏與持續閱讀作品的人",
    ],
  },
  bottomCta: {
    title: "想了解更多？",
    description: "你可以查看合作通路找到千華駐科技出版有限公司的書，或前往崧博出版書籍資料庫查詢完整書目資訊。",
    buttons: [
      { label: "查看合作通路", href: "/stores" },
      { label: "崧博出版書籍資料庫", href: "https://catalog.sonbook.net/", external: true },
    ],
  },
};

export const faqPageData = {
  hero: {
    title: "千華駐科技出版有限公司常見問題",
    intro: [
      "本頁整理千華駐科技出版有限公司常見問題，內容包含青城十九俠系列、大華文苑書系、正式書目查詢、合作購書通路及品牌資訊。",
      "千華駐科技出版有限公司以青城十九俠系列與大華文苑書系為主要出版方向。",
      "本品牌委託崧博出版經銷，官方網站由崧博出版製作。完整書名、作者、ISBN與出版日期請以正式書目資料為準；價格、版本、庫存及購買方式則以各合作通路頁面為準。",
    ],
  },
  categories: [
    {
      title: "關於千華駐科技出版有限公司",
      faqs: [
        {
          q: "千華駐科技出版有限公司是什麼品牌？",
          a: "千華駐科技出版有限公司以青城十九俠系列與大華文苑書系為主要出版方向。本品牌委託崧博出版經銷，官方網站由崧博出版製作。網站提供品牌介紹、書系資訊與最新發行書籍。",
        },
        {
          q: "千華駐科技出版有限公司主要出版科技類書籍嗎？",
          a: "不是以品牌名稱中的「科技」作為出版分類。千華駐科技出版有限公司目前已確認的代表內容包括武俠小說《青城十九俠》，以及涵蓋大眾閱讀、自然科普與奇觀解謎的大華文苑書系。",
        },
        {
          q: "千華駐科技出版有限公司與崧博出版是什麼關係？",
          a: "本品牌委託崧博出版經銷，官方網站由崧博出版製作。讀者可透過千華駐科技品牌網站瀏覽相關出版內容，並前往崧博書籍資料庫查詢正式書目。",
        },
        {
          q: "千華駐科技出版有限公司網站提供哪些資訊？",
          a: "網站主要提供品牌介紹、《青城十九俠》與大華文苑書系相關出版資訊、正式書目、合作購書通路及常見問題。",
        },
      ],
    },
    {
      title: "青城十九俠",
      faqs: [
        {
          q: "《青城十九俠》是什麼系列？",
          a: "青城十九俠系列是千華駐科技出版有限公司的重要武俠小說系列。\n完整分冊書名、作者、ISBN、出版日期及版本資訊，請以正式書目資料為準。",
        },
        {
          q: "《青城十九俠》共有幾冊？",
          a: "個別冊次、分冊書名與完整出版資訊，請以崧博書籍資料庫中的正式書目為準。",
        },
        {
          q: "網站會列出《青城十九俠》所有冊次嗎？",
          a: "網站只應顯示目前已建立且具有正式書目資料的作品。若需要確認完整套書及分冊資訊，請前往崧博出版書籍資料庫查詢。",
        },
        {
          q: "《青城十九俠》可以整套購買嗎？",
          a: "是否提供全套商品、單冊商品或特定組合，應以各合作購書通路的實際上架資訊為準。",
        },
        {
          q: "《青城十九俠》是2026年新書嗎？",
          a: "是否屬於2026年最新發行書籍，應依各冊正式出版日期判定。不得僅因網站新增展示，就將舊作品標示為2026新書。",
        },
      ],
    },
    {
      title: "大華文苑書系",
      faqs: [
        {
          q: "大華文苑書系是什麼？",
          a: "大華文苑書系是一個聚焦於大眾閱讀、自然科普與奇觀解謎的通俗圖書系列。",
        },
        {
          q: "大華文苑書系主要包含哪些內容？",
          a: "大華文苑書系主要涵蓋大眾閱讀、自然科普與奇觀解謎，透過易於進入的文字與探索性主題，提供兼具知識性與閱讀趣味的內容。",
        },
        {
          q: "什麼是大眾閱讀？",
          a: "大眾閱讀指以一般讀者容易理解與進入的方式呈現知識、故事或探索主題，不以特定專業背景作為閱讀前提。",
        },
        {
          q: "什麼是自然科普類內容？",
          a: "自然科普類內容以通俗方式介紹自然現象、科學知識、生物、地理或其他與自然世界相關的主題。實際涵蓋類別仍以現有正式書目為準。",
        },
        {
          q: "什麼是奇觀解謎類內容？",
          a: "奇觀解謎類內容從自然奇觀、世界現象、未知謎題或探索性題材出發，介紹事件背景、知識脈絡與可能解釋。",
        },
        {
          q: "大華文苑書系適合哪些讀者？",
          a: "適合喜歡大眾知識、自然科普、奇觀探索與通俗閱讀內容，並希望以容易進入的方式理解不同主題的讀者。",
        },
      ],
    },
    {
      title: "出版內容與閱讀方向",
      faqs: [
        {
          q: "千華駐科技出版有限公司主要有哪些出版方向？",
          a: "千華駐科技出版有限公司以青城十九俠系列與大華文苑書系為主要出版方向。",
        },
        {
          q: "千華駐科技出版有限公司的武俠小說與科普書籍有什麼關係？",
          a: "兩者屬於不同的出版內容方向。《青城十九俠》代表武俠小說系列，大華文苑書系則主要聚焦大眾閱讀、自然科普與奇觀解謎。",
        },
        {
          q: "網站上的分類代表所有出版作品嗎？",
          a: "網站分類用於整理目前已確認的主要出版方向，實際作品主題、分類與書系歸屬，仍應以個別書籍介紹及正式書目資料為準。",
        },
      ],
    },
    {
      title: "書籍與正式書目",
      faqs: [
        {
          q: "如何查詢千華駐科技出版有限公司的出版書籍？",
          a: "可先瀏覽千華駐科技出版有限公司品牌網站目前公開的出版內容。如需確認完整書名、作者、ISBN、出版日期及其他正式書目資訊，請前往崧博出版書籍資料庫查詢。",
        },
        {
          q: "網站上的書籍資料以哪裡為準？",
          a: "完整書名、作者、ISBN、出版日期及其他正式出版資訊，應以崧博出版書籍資料庫與正式公開書目為準。",
        },
        {
          q: "如何使用ISBN查找書籍？",
          a: "ISBN可用於辨識特定出版品。若書名較長、同名作品較多或搜尋結果不明確，建議使用ISBN查詢。",
        },
        {
          q: "網站上的內容簡介是完整書籍內容嗎？",
          a: "不是。網站上的內容簡介主要協助讀者了解作品主題與閱讀方向，完整內容仍以正式出版品為準。",
        },
        {
          q: "2026最新發行書籍如何判定？",
          a: "2026最新發行書籍只顯示正式出版年份為2026年，且已有確認書目資料的作品，並依正式出版日期由新到舊排列。",
        },
      ],
    },
    {
      title: "購書通路、價格與庫存",
      faqs: [
        {
          q: "在哪裡可以購買千華駐科技出版有限公司的書？",
          a: "可透過網站合作購書通路頁所列的正式平台查找。不同作品實際上架的平台可能不同，請以各通路頁面顯示為準。",
        },
        {
          q: "所有書籍都會在全部合作通路上架嗎？",
          a: "不一定。不同作品的上架平台、版本與供應狀態可能不同，實際資訊請以各合作購書通路頁面為準。",
        },
        {
          q: "為什麼在某個平台找不到書籍？",
          a: "建議先至崧博出版書籍資料庫確認正式書名、作者與ISBN，再前往其他網站已建立的合作購書通路查找。",
        },
        {
          q: "網站顯示的價格是最終售價嗎？",
          a: "不是。書籍價格、折扣及促銷活動可能由各合作通路調整，實際售價請以通路頁面與結帳資訊為準。",
        },
        {
          q: "網站可以查詢即時庫存嗎？",
          a: "千華駐科技出版有限公司品牌網站不保證提供各通路即時庫存。實際庫存、配送及到貨資訊，請以各合作購書通路頁面為準。",
        },
        {
          q: "缺貨的書籍一定會補貨嗎？",
          a: "不一定。補貨、再版與重新上架狀態，需依實際出版及通路情況而定。",
        },
      ],
    },
    {
      title: "品牌經銷與合作",
      faqs: [
        {
          q: "如何洽詢千華駐科技出版有限公司品牌合作？",
          a: "如有千華駐科技品牌經銷、通路合作、內容合作、媒體或其他相關合作需求，請透過網站現有的官方聯絡方式提出詢問。\n品牌經銷與合作方案詳情請直接聯繫洽詢。",
        },
        {
          q: "千華駐科技出版有限公司是否提供出版代辦服務？",
          a: "千華駐科技品牌網站目前不宣稱提供出版代辦、排版代工、印刷代工、發行代辦或上架代辦服務。",
        },
        {
          q: "千華駐科技出版有限公司是否提供科技顧問或軟體服務？",
          a: "千華駐科技品牌網站不因品牌名稱包含「科技」而提供或宣稱提供科技顧問、軟體開發、AI系統、程式設計或數位轉型服務。",
        },
        {
          q: "千華駐科技出版有限公司是否提供電子書或有聲書製作？",
          a: "千華駐科技品牌網站目前不宣稱提供電子書、EPUB、POD或有聲書製作代工服務。",
        },
        {
          q: "合作洽詢是否保證出版、上架或銷售？",
          a: "合作洽詢不代表保證出版、上架、曝光或銷售成果，實際合作內容仍需依雙方確認為準。",
        },
      ],
    },
    {
      title: "網站使用問題",
      faqs: [
        {
          q: "網站支援手機瀏覽嗎？",
          a: "網站採響應式設計，主要頁面可於桌面、平板與手機瀏覽，實際版面會依螢幕尺寸調整。",
        },
        {
          q: "點擊導覽列後為什麼會回到頁面頂端？",
          a: "網站切換首頁、品牌介紹、合作購書通路及常見問題頁時，會將新頁面的瀏覽位置重設至頂端，以便從頁面開頭開始閱讀。",
        },
        {
          q: "為什麼頁面內容會有進場動畫？",
          a: "主要Section進入可視範圍時會播放一次輕量動畫。若裝置設定偏好減少動畫，網站應簡化或停用相關效果。",
        },
      ],
    },
  ],
  bottomCta: {
    catalog: {
      title: "查詢千華駐科技出版有限公司正式書目",
      description:
        "如需確認《青城十九俠》、大華文苑書系及其他出版作品的完整書名、作者、ISBN、出版日期與正式出版資訊，請前往崧博出版書籍資料庫查詢。",
      buttonLabel: "查詢完整書目",
      buttonHref: "https://catalog.sonbook.net/",
    },
    channels: {
      title: "查看千華駐科技出版有限公司合作購書通路",
      description:
        "千華駐科技出版有限公司相關書籍可透過網站已建立的合作購書通路查找。價格、版本、庫存、配送及購買方式請以各通路頁面為準。",
      buttonLabel: "查看合作購書通路",
      buttonHref: "/stores",
    },
  },
};

export const channelsPageData = {
  hero: {
    title: "合作通路",
    subtitle: "讀者可透過以下通路平台搜尋千華駐科技出版有限公司相關作品。不同平台的上架狀態與銷售方式可能不同，實際資訊請以各平台頁面為準。完整書目資訊可前往崧博出版書籍資料庫查詢。",
  },
  platforms: [
    {
      name: "博客來",
      description: "博客來網路書店品牌書目，可搜尋千華駐科技出版有限公司完整出版書目。",
      url: "https://www.books.com.tw/web/sys_puballb/books/?pubid=qianhua1",
      icon: "ri-book-3-line",
      primary: true,
    },
    {
      name: "誠品",
      description: "誠品線上搜尋千華駐科技出版有限公司相關作品。",
      url: "https://www.eslite.com/search?keyword=千華駐科技出版有限公司",
      icon: "ri-book-2-line",
      primary: false,
    },
    {
      name: "金石堂",
      description: "金石堂網路書店品牌出版專區，瀏覽千華駐科技出版有限公司出版作品。",
      url: "https://www.kingstone.com.tw/bookpublish/publist/61894/",
      icon: "ri-store-line",
      primary: false,
    },
    {
      name: "三民",
      description: "三民網路書店搜尋千華駐科技出版有限公司出版品。",
      url: "https://www.sanmin.com.tw/search?pu=千華駐科技",
      icon: "ri-book-open-line",
      primary: false,
    },
    {
      name: "momo",
      description: "momo 購物網品牌館搜尋千華駐科技出版有限公司作品。",
      url: "https://www.momoshop.com.tw/search/千華駐科技出版有限公司?brand=千華駐科技出版有限公司",
      icon: "ri-shopping-bag-line",
      primary: false,
    },
    {
      name: "蝦皮",
      description: "蝦皮購物崧博出版賣場，可搜尋千華駐科技出版有限公司相關作品。",
      url: "https://shopee.tw/sonbook",
      icon: "ri-shopping-cart-line",
      primary: false,
    },
    {
      name: "Amazon Kindle",
      description: "Amazon Kindle 電子書平台搜尋千華駐出版品。",
      url: "https://www.amazon.com/s?k=千華駐",
      icon: "ri-book-read-line",
      primary: false,
    },
    {
      name: "TAAZE 讀冊",
      description: "TAAZE 讀冊生活搜尋千華駐科技出版有限公司出版品。",
      url: "https://www.taaze.tw/rwd_searchResult.html?keyType%5B%5D=3&keyword%5B%5D=千華駐科技出版有限公司",
      icon: "ri-bookmark-2-line",
      primary: false,
    },
    {
      name: "樂天 Kobo",
      description: "樂天 Kobo 電子書平台，搜尋千華駐科技出版有限公司相關電子書。",
      url: "https://www.kobo.com/tw/zh",
      icon: "ri-tablet-line",
      primary: false,
    },
    {
      name: "Pubu",
      description: "Pubu 電子書城千華駐科技出版有限公司出版專區。",
      url: "https://www.pubu.com.tw/store/4193937",
      icon: "ri-smartphone-line",
      primary: false,
    },
    {
      name: "OverDrive",
      description: "OverDrive 圖書館電子書平台搜尋千華駐科技出版有限公司出版品。",
      url: "https://www.overdrive.com/publishers/千華駐科技",
      icon: "ri-global-line",
      primary: false,
    },
    {
      name: "MyBook",
      description: "台灣大哥大 MyBook 電子書平台，搜尋千華駐科技出版有限公司作品。",
      url: "https://mybook.mobi/mybook/zh-TW/#",
      icon: "ri-book-line",
      primary: false,
    },
    {
      name: "Hami Book",
      description: "中華電信 Hami 書城搜尋千華駐科技出版有限公司出版作品。",
      url: "https://www.hamibook.com.tw/Search/finish?keyword=千華駐科技",
      icon: "ri-search-line",
      primary: false,
    },
  ],
  bottomCta: {
    title: "還有其他問題？",
    description: "關於出版方向、適合讀者或購書方式的疑問，歡迎查看常見問答或前往崧博出版書籍資料庫。",
    buttons: [
      { label: "常見問答", href: "/faq" },
      { label: "認識千華駐科技出版有限公司", href: "/about" },
    ],
  },
};
